import { combineReducers, configureStore } from "@reduxjs/toolkit";
import homeSlice from "../Features/homeSlice";

const rootReducer = combineReducers({
  isDashboard: homeSlice,
});

const Store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
});

export { Store };
